import React, { PropTypes } from "react";
import SyncedNotificationsListItem from "../dashboard/SyncedNotificationsListItem";
import { FormattedMessage } from "react-intl";
import Toggle from "react-toggle";
import { Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import { RectangleSpinner } from "../common/spinners";
import { SYNC_NOTIFICATIONS_GRAPHQL } from "../../utils/data/models";
import { buildGraphQLQueryParams } from "../common/GraphQL/GraphQLQueryHelper";
import api from "../../utils/data/dataApi";

class SyncedNotificationsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggles: ["onlyErrors", "onlyMyModifications"],
            notifications: null,
            loading: false,
        };
    }

    componentDidMount() {
        this.fetchSyncNotifications();
    }

    handleToggleChange = (event, filterName) => {
        const { toggles } = this.state;
        const newToggles = toggles.includes(filterName)
            ? toggles.filter((t) => t !== filterName)
            : [...toggles, filterName];
        this.setState({ toggles: newToggles });
    };

    openSyncDataTable = () => {
        window.open("/dashboard/synchronizations", "_blank");
    };

    fetchSyncNotifications = () => {
        this.setState({ loading: true });
        const colsStr = `
      dependentPersonCoverageSyncId
      dependentPersonCoverageId
      memberCoverageSyncId
      memberCoverageId
      classSyncId
      classId
      divisionSyncId
      divisionId
      clientSyncId
      clientId
      syncDate
      errors
      client {
        name
        clientId
        clientNumber
      }
      division {
        name
        divisionId
        externalDivisionNumber
      }
      status
      provider
      elementType
      member {
        memberId
        firstName
        lastName
        memberIdentifier
      }
      user {
        userId
        firstName
        lastName
      }
      dependentPerson {
        dependentPersonId
        firstName
        lastName
      }
      class_ {
        classId
        name
        externalClassNumber
      }
      eventName
      isEligibleForResync
    `;

        let filters = [
            `onlyErrors==${this.state.toggles.includes("onlyErrors")}`,
            `onlyMyModifications==${this.state.toggles.includes("onlyMyModifications")}`,
        ];
        const graphQLQuery = buildGraphQLQueryParams(
            "syncedData",
            filters,
            SYNC_NOTIFICATIONS_GRAPHQL.defaultSort,
            0,
            200,
            colsStr,
            "syncedData",
            ""
        );

        let response = api.getGraphQL(SYNC_NOTIFICATIONS_GRAPHQL, { query: graphQLQuery });
        this.setState({ notifications: null });
        response
            .then((data) => {
                const items = data.data.syncedData.items;
                this.setState({ notifications: items, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        const { loading } = this.state;
        return (
            <div className="notes-wrapper opened full-width" style={{ height: "calc(100vh - 40px)", position: "sticky" }}>
                {this.props.showSyncNotificationsList && (
                    <div className="sync-notification-notes">
                        <div className="sync-header show" style={{ contentVisibility: "auto" }}>
                            <h4>
                                <FormattedMessage id="clients.client.processSync.notificationsBoard.title" />
                            </h4>

                            <div className="toggle-buttons-container">
                                <label className="toggle-color">
                                    <Toggle
                                        disabled={loading}
                                        icons={{ checked: null, unchecked: null }}
                                        defaultChecked={true}
                                        onChange={(event) => this.handleToggleChange(event, "onlyMyModifications")}
                                    />
                                    <span>
                                        <FormattedMessage id="clients.client.processSync.notificationsBoard.filters.onlyMyModifications" />
                                    </span>
                                </label>

                                <label className="toggle-color">
                                    <Toggle
                                        disabled={loading}
                                        icons={{ checked: null, unchecked: null }}
                                        defaultChecked={true}
                                        onChange={(event) => this.handleToggleChange(event, "onlyErrors")}
                                    />
                                    <span>
                                        <FormattedMessage id="clients.client.processSync.notificationsBoard.filters.onlyErrors" />
                                    </span>
                                </label>
                            </div>
                            <Button
                                bsStyle="primary"
                                className="filter-btn"
                                disabled={loading}
                                onClick={() => this.fetchSyncNotifications()}
                                style={{ float: "inline-end", marginTop: "15px" }}
                            >
                                <FormattedMessage id="clients.client.processSync.notificationsBoard.actions.reload" />
                            </Button>
                        </div>
                        <div className="sync-scroll">
                            <Scrollbars autoHide={true} style={{ height: "100%" }}>
                                {(!!this.state.notifications && (
                                    <div className="notes-list">
                                        {this.state.notifications.map((notification) => (
                                            <SyncedNotificationsListItem
                                                key={Math.random()}
                                                syncNotification={notification}
                                            />
                                        ))}
                                    </div>
                                )) || <RectangleSpinner />}
                            </Scrollbars>
                        </div>
                        <div className="sync-footer">
                            <Button
                                bsStyle="primary"
                                className="filter-btn"
                                onClick={() => this.openSyncDataTable()}
                                disabled={loading}
                            >
                                <FormattedMessage id="clients.client.processSync.notificationsBoard.actions.seeMore" />
                            </Button>
                        </div>
                    </div>
                )}

                {this.props.showSyncNotificationsList && (
                    <div
                        className="overlay"
                        style={{ position: "fixed" }}
                        onClick={() => {
                            this.props.onClose();
                        }}
                    />
                )}
            </div>
        );
    }
}

SyncedNotificationsList.propTypes = {
    showSyncNotificationsList: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default SyncedNotificationsList;



// WEBPACK FOOTER //
// ./src/components/dashboard/SyncedNotificationsList.js